import { render, staticRenderFns } from "./distributionList.vue?vue&type=template&id=60ea2c78&"
import script from "./distributionList.vue?vue&type=script&lang=js&"
export * from "./distributionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports